import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import { useNavigate, useLocation, useParams } from "react-router-dom";

// 우측에 띄울 등록/수정 컴포넌트 임포트
import TAB_ProduceWorkReg from "./TAB_ProduceWorkReg";
import TAB_ProduceWorkDetail from "./TAB_ProduceWorkDetail";

const TAB_ProduceWork = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [keyword, setKeyword] = useState({ search:'', status:'' });
    const [userTypeModalOption, setUserTypeModalOption] = useState([]);
    const [qualityYnModalOption, setQualityYnModalOption] = useState([]);
    
    // 우측 화면 전환 State
    const [isRegModalOpen, setRegModalOpen] = useState(false);
    const [isDetailModalOpen, setDetailModalOpen] = useState(false);
    const [selectItemID, setSelectItemID] = useState('');
    const [statusOption, setStatusOption] = useState([]);
    const [paramID, setParamID] = useState('');
    const [initialEditOpenDone, setInitialEditOpenDone] = useState(true);

    // 🚨 부모 컨테이너(min-height: calc(100vh - 100px))에 딱 맞춤.
    //    100px = 헤더 65 + 고정 footer 35. 태블릿에서 스크롤 남으면 100vh → 100dvh 로 바꾸세요.
    const availHeight = 'calc(100vh - 100px)';

    const handleSetting = () => {
        setColumns([
            (MenuDeleteExistYN === "Y" ?
            {
                field: 'deleted', headerName: '삭제', width: 56, type: 'actions', headerAlign: 'center',
                getActions: (params) => [
                    <GridActionsCellItem
                        icon={<DeleteIcon color={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y' ? "error" : "disabled" } />}
                        onClick={() => DeleteClick(params)}
                        label="Delete"
                        disabled={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y' ? false : true }
                    />
                ]
            } : { field: 'deleted', headerName: '', width: 0 }),
            { field: 'id', headerName: 'produce_work_id', width: 0, headerAlign: 'center' },
            { field: 'produce_work_status', headerName: 'produce_work_status', width: 0, headerAlign: 'center' },
            { field: 'produce_work_number', headerName: '번호', width: 120, headerAlign: 'center', align: 'center' },
            { field: 'produce_work_item_name', headerName: '품목', flex: 1, minWidth: 160, headerAlign: 'center', align: 'left' },
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false, produce_work_status: false, produce_work_number: true, order_name: true,
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            if(params.produce_work_id !== null && typeof params.produce_work_id !== 'undefined'){ setParamID(params.produce_work_id); }
        }else{
            Swal.fire({ title: '<p style="color:red">접근 권한 오류</p>', text: '화면에 접근 권한이 없습니다.', confirmButtonText: '확인', confirmButtonColor: '#7066e0', timer:5000, timerProgressBar: true }).then(() => { navigate(-1); });
        }
    }, []);
    
    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleView(); setRegModalOpen(false); setDetailModalOpen(false);
        }
    }, [keyword.status]);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting(); handleInitSelect(); handleInit(); handleView();
        }
    }, [MenuID]);
    
    useEffect(() => {
        if (originRows.length > 0 && paramID && initialEditOpenDone) {
            const filtered = originRows.filter(row => String(row.produce_work_id) === String(paramID));
            if (filtered.length > 0) {
                setSelectItemID(paramID); setRegModalOpen(false); setDetailModalOpen(true); setInitialEditOpenDone(false);
            }
        }
    }, [originRows, paramID]);

    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        axios.get('/api/p/ProduceWork/List', { params : { search : keyword.search, status : keyword.status } }, { withCredentials: true })
        .then((response) => {
            const PermissionMap = {};
            response.data.forEach((row) => {
                if (!PermissionMap[row.produce_work_id]) {
                    PermissionMap[row.produce_work_id] = [row.reg_user_id, row.update_user_id, row.produce_work_user_id].includes(Number(localStorage.getItem('user_id')));
                }
            });
            var array = response.data.map((item, index) => ({ id: item.produce_work_id, produce_work_number: item.produce_work_number, produce_work_status: item.produce_work_status, produce_work_item_name: item.produce_work_item_name, update_flag: PermissionMap[item.produce_work_id] ? 'Y' : 'N' }));
            setOriginRows(response.data); setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        }).catch((error) => { appStore.capture(); }).finally(() => { appStore.setLoading(false); });
    }

    const handleInitSelect = () => {
        setStatusOption([{value:'', label:'전체'}, {value:'E', label:'작업완료'}]);
        axios.get('/api/Common/CodeDetailList').then((response) => { 
            var user_type_array_modal = []; var quality_yn_array_modal = [{value:'Y', label:'Y'}, {value:'N', label:'N'}];
            for(let i=0; i<(response.data).length; i++){
                if((response.data)[i].code_id === '0020') user_type_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
            }
            setQualityYnModalOption(quality_yn_array_modal); setUserTypeModalOption(user_type_array_modal);
        }).catch((error) => console.log(error));
    }

    const handleInit = () => { setKeyword({ search: '', status: '' }); };
    const handleReg = () => { setDetailModalOpen(false); setRegModalOpen(true); };
    const UpdateClick = (params) => { setRegModalOpen(false); setDetailModalOpen(true); setSelectItemID(params.row.id); };

    const DeleteClick = (object) => {
        Swal.fire({
            title: '생산작업번호 '+object.row.produce_work_number+' 삭제',
            html : '생산작업번호 '+object.row.produce_work_number+'을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton : true, confirmButtonColor : "#d33", confirmButtonText : "삭제", cancelButtonText : "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);
                axios.post('/api/p/ProduceWork/Delete', new URLSearchParams({ delete_produce_work_id: object.row.id, folder: 'ProduceWork' }), { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){
                        Swal.fire({ title: '생산작업번호 '+object.row.produce_work_number+' 삭제 완료', text: '정상적으로 생산작업번호 '+object.row.produce_work_number+'가 삭제 되었습니다.', confirmButtonText: '확인', timer: 5000, timerProgressBar: true }).then(() => {
                            setRows((rows) => rows.filter((data) => data.id !== object.row.id));
                            setRegModalOpen(false); setDetailModalOpen(false);
                        });
                    }else{ appStore.capture(); }
                }).catch(function (error) { appStore.capture(); }).finally(() => { appStore.setLoading(false); });
            }
        });
    };
    const onSelectChange = (type, value) => setKeyword({ ...keyword, [type] : value });
    const onChange = (e) => setKeyword({ ...keyword, [e.target.name]: e.target.value });
    const onSubmitSearch = (e) => { if (e.key === "Enter") handleView(); };
    
    const handleRegSuccessSave = (regID) => {
        setRegModalOpen(false); handleView();
        Swal.fire({ title: '생산작업 등록 완료', text: '정상적으로 생산작업가 등록 되었습니다.', confirmButtonText: '확인', timer: 5000, timerProgressBar: true }).then(() => {
            setDetailModalOpen(true); setSelectItemID(Number(regID));
        });
    };

    return (
        <div style={{ display: String(MenuID) === String(0) ? 'none' : 'flex', flexDirection: 'column', width: '100%', height: availHeight, backgroundColor: '#fff', overflow: 'hidden' }}>
            
            {/* 🚨 1. 상단 슬림형 검색바 (오류의 원인이던 menubox 클래스 제거) */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px', borderBottom: '1px solid #ccc', backgroundColor: '#fff', minHeight: '60px', flexShrink: 0 }}>
                {/* 좌측 타이틀 */}
                <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#333', display: 'flex', alignItems: 'center' }}>
                    <span style={{ width: '5px', height: '30px', backgroundColor: '#3D63AE', marginRight: '10px' }}></span>
                    {MenuName}
                </div>
                
                {/* 우측 검색조건 및 버튼 */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ fontSize: '16px', fontWeight: 'bold' }}>생산작업상태</span>
                        <div style={{ width: '130px' }}>
                            <Select onChange={(e) => onSelectChange('status',e.value)} value={statusOption.filter(option => option.value === keyword.status)} options={statusOption} placeholder="상태" />
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input type="text" className="btn-p" placeholder="검색" value={keyword.search} name="search" onChange={onChange} onKeyPress={onSubmitSearch} autoComplete="off" style={{ width: '200px', height: '38px', border: '1px solid #ccc', borderRadius: '4px', padding: '0 10px' }} />
                    </div>
                    <div style={{ display: 'flex', gap: '8px', marginLeft: '10px' }}>
                        {MenuUpdateYN === "Y" && <Button onClick={handleReg} className="btn-p" sx={{ fontSize: 14, minWidth: '70px', color: "white", backgroundColor: "#FF3636", borderColor: "#FF3636", ":hover": {backgroundColor: "#FF3636"} }} variant="outlined">등록</Button>}
                        <Button onClick={handleInit} className="btn-p" sx={{ fontSize: 14, minWidth: '70px', color: "white", backgroundColor: "black", borderColor: "black", ":hover": {backgroundColor: "black"} }} variant="outlined">초기화</Button>
                        <Button onClick={handleView} className="btn-p" sx={{ fontSize: 14, minWidth: '70px', color: "white", backgroundColor: "#3D63AE", borderColor: "#3D63AE", ":hover": {backgroundColor: "#3D63AE"} }} variant="outlined">조회</Button>
                    </div>
                </div>
            </div>

            {/* 🚨 2. 하단 2단 분할 영역 (100% 꽉 채우기) */}
            <div style={{ display: 'flex', flex: 1, width: '100%', overflow: 'hidden' }}>
                
                {/* 👈 좌측 리스트 (400px 고정) */}
                <div style={{ width: '400px', borderRight: '1px solid #ccc', display: 'flex', flexDirection: 'column', backgroundColor: '#fff' }}>
                    <div style={{ flex: 1, width: '100%' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            slots={{ noRowsOverlay: GridNoRow }}
                            columnVisibilityModel={columnVisibilityModel}
                            AlternatingRowBackground="LavenderBlush"
                            rowsPerPageOptions={[20, 50, 100]}
                            onRowClick={(params) => UpdateClick(params)} 
                            sx={{ height: '100%', border: 'none' }} // 높이 100% 꽉 채움
                        />
                    </div>
                </div>

                {/* 👉 우측 상세/등록 폼 */}
                <div style={{ flex: 1, backgroundColor: '#f9f9f9', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    {isRegModalOpen ? (
                        <TAB_ProduceWorkReg onClose={() => setRegModalOpen(false)} handleRegSuccessSave={handleRegSuccessSave} userTypeModalOption={userTypeModalOption} qualityYnModalOption={qualityYnModalOption} MenuUpdateYN={MenuUpdateYN} />
                    ) : isDetailModalOpen ? (
                        <TAB_ProduceWorkDetail onClose={() => setDetailModalOpen(false)} id={selectItemID} originRows={originRows.filter(row => String(row.produce_work_id) === String(selectItemID))} handleView={handleView} userTypeModalOption={userTypeModalOption} qualityYnModalOption={qualityYnModalOption} MenuUpdateYN={MenuUpdateYN} MenuDeleteYN={MenuDeleteYN} />
                    ) : (
                        <div style={{ display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center', fontSize: '18px', color: '#999', fontWeight: 'bold' }}>
                            👈 좌측 리스트에서 생산작업를 선택하거나 상단의 등록 버튼을 클릭하세요.
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default TAB_ProduceWork;